// extracted by mini-css-extract-plugin
module.exports = {"category":"categories-module--category--368Ex"};